<template>
    <component
        :is="element"
        class="btn d-inline-flex align-items-center btn-fix-padding d-print-none"
        :class="`btn-${variant} btn-${size} ${isDisabled ? 'element-disabled' : ''} ${loading ? 'position-relative' : ''}`"
        :href="isDisabled ? null : href"
        :target="linkTarget"
        :disabled="isDisabled"
        :aria-disabled="isDisabled || null"
        type="button"
        :download="download || null"
        :role="element === 'a' ? 'link' : null"
        @click="onClick"
    >
        <b-spinner v-if="loading" class="position-absolute mx-auto" :style="spinnerStyle"></b-spinner>
        <span v-if="!iconLeft" class="btn-label" :class="[{'opacity-20': loading}, srOnly]">
            {{ label }}
            <slot></slot>
        </span>
        <span v-if="icon" class="btn-icon" :class="{'opacity-20': loading}">
            <font-awesome-icon :icon="icon"></font-awesome-icon>
        </span>
        <!-- Text on right side when icon-left was passed -->
        <span v-if="iconLeft" class="btn-label" :class="[{'opacity-20': loading}, srOnly]">
            {{ label }}
            <slot></slot>
        </span>
    </component>
</template>

<script>
import LinkTarget from '@/mixins/LinkTarget'

// When used within b-popover default slot, global components don't work and have to be registered again
import {BSpinner} from 'bootstrap-vue'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
import {Link as InertiaLink} from '@inertiajs/vue3'

export default {
    components: {
        BSpinner,
        FontAwesomeIcon,
        InertiaLink,
    },
    mixins: [
        LinkTarget,
    ],
    props: {
        component: {type: String, default: 'button'},
        href: String,
        variant: {type: String, default: 'primary'},
        size: {type: String, default: 'md'},
        label: String,
        labelSize: String,
        hideLabel: [Boolean, String],
        icon: [String, Array],
        iconLeft: Boolean,
        disabled: Boolean,
        inertiaLink: Boolean,
        download: [Boolean, String],
        loading: Boolean,
    },
    emits: ['click'],
    computed: {
        isDisabled() {
            return this.disabled || this.loading
        },
        element() {
            return this.inertiaLink ? 'inertia-link' : this.component
        },
        srOnly() {
            let srOnly = 'sr-only'
            if(typeof this.hideLabel === 'string') {
                return `${srOnly}-${this.hideLabel}`
            } else if(this.hideLabel) {
                return `${srOnly}`
            }
            return ''
        },
        spinnerStyle() {
            return {
                left: 0,
                right: 0,
                width: '1.7rem',
                height: '1.7rem',
            }
        },
    },
    methods: {
        onClick() {
            this.$emit('click')
        }
    },
}
</script>
